var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResetZoomWhiteBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Navigation",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157145",
    "data-name": "Rectangle 157145",
    width: 38,
    height: 38,
    rx: 8,
    transform: "translate(38) rotate(90)",
    fill: "#fff",
    stroke: "#e8eaee",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "invisible_box",
    "data-name": "invisible box"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157085",
    "data-name": "Rectangle 157085",
    width: 24,
    height: 24,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_75080",
    "data-name": "Group 75080",
    transform: "translate(-14200 5052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "zoom_out_map_20dp_5F6368_FILL0_wght300_GRAD0_opsz20",
    d: "M166.539-779.481h1.619a.72.72,0,0,1,.528.211.708.708,0,0,1,.213.523.727.727,0,0,1-.213.529.71.71,0,0,1-.528.217h-3.242a.886.886,0,0,1-.652-.263.886.886,0,0,1-.263-.653v-3.242a.72.72,0,0,1,.211-.528.708.708,0,0,1,.523-.213.727.727,0,0,1,.529.213.71.71,0,0,1,.217.528v1.619l3.1-3.1a.75.75,0,0,1,.524-.242.727.727,0,0,1,.535.242.742.742,0,0,1,.247.529.743.743,0,0,1-.247.529Zm12.922,0-3.1-3.1a.7.7,0,0,1-.228-.524.783.783,0,0,1,.256-.535.742.742,0,0,1,.529-.247.743.743,0,0,1,.529.247l3.074,3.1v-1.619a.72.72,0,0,1,.211-.528.708.708,0,0,1,.523-.213.727.727,0,0,1,.529.213.71.71,0,0,1,.217.528v3.242a.886.886,0,0,1-.263.653.886.886,0,0,1-.652.263h-3.242a.72.72,0,0,1-.528-.211.709.709,0,0,1-.213-.523.727.727,0,0,1,.213-.529.71.71,0,0,1,.528-.217Zm-13.98-13.98v1.619a.72.72,0,0,1-.211.528.708.708,0,0,1-.523.213.727.727,0,0,1-.529-.213.71.71,0,0,1-.217-.528v-3.242a.886.886,0,0,1,.263-.653.886.886,0,0,1,.652-.263h3.242a.72.72,0,0,1,.528.211.709.709,0,0,1,.213.523.727.727,0,0,1-.213.529.71.71,0,0,1-.528.217h-1.619l3.1,3.1a.736.736,0,0,1,.242.51.713.713,0,0,1-.242.52.742.742,0,0,1-.529.247.743.743,0,0,1-.529-.247Zm15.038,0-3.1,3.1a.681.681,0,0,1-.51.228.771.771,0,0,1-.52-.256.742.742,0,0,1-.247-.529.743.743,0,0,1,.247-.529l3.074-3.074h-1.619a.72.72,0,0,1-.528-.211.708.708,0,0,1-.213-.523.727.727,0,0,1,.213-.529.71.71,0,0,1,.528-.217h3.242a.886.886,0,0,1,.652.263.886.886,0,0,1,.263.653v3.242a.72.72,0,0,1-.211.528.708.708,0,0,1-.523.213.727.727,0,0,1-.529-.213.71.71,0,0,1-.217-.528Z",
    transform: "translate(14039 -4253)",
    fill: "#2e4d7b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "check_box_outline_blank_20dp_5F6368_FILL0_wght400_GRAD0_opsz20",
    d: "M144.892-807.675a.859.859,0,0,1-.63-.262.859.859,0,0,1-.262-.63v-6.541a.859.859,0,0,1,.262-.63.859.859,0,0,1,.63-.262h6.541a.859.859,0,0,1,.63.262.859.859,0,0,1,.262.63v6.541a.859.859,0,0,1-.262.63.859.859,0,0,1-.63.262Zm0-.892h6.541v-6.541h-6.541Z",
    transform: "translate(14064 -4228)",
    fill: "#2e4d7b",
    stroke: "#2e4d7b",
    strokeWidth: 0.5
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetZoomWhiteBackground);
export default __webpack_public_path__ + "static/media/ResetZoomWhiteBackground.99e63d07fd6aa9b5b81e8cde11e3069c.svg";
export { ForwardRef as ReactComponent };